export default "__VITE_ASSET__DEXgEjlN__"